import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { SendReview } from "../../../components/common/SendReview";

export const ReviewModal = ({
  showReviewModal,
  setShowReviewModal,
  profile,
  slugdata,
  onReviewSubmitted
}) => {
  const [submissionState, setSubmissionState] = useState('form');
  const [checkData, setCheckData] = useState("");

  const handleClose = () => {
    if (submissionState !== 'success') {
      setShowReviewModal(false);
    }
  };

  const handleSuccess = () => {
    setSubmissionState('success');
    onReviewSubmitted?.();
  };

  return (
    <Modal show={showReviewModal} onHide={handleClose}>
      <Modal.Body>
        <SendReview
          setrequest={(shouldClose) => {
            if (shouldClose === false || submissionState === 'success') {
              setShowReviewModal(false);
            }
          }}
          slugdata={slugdata.id}
          username={profile.first_name + " " + profile.last_name}
          setcheckdata={setCheckData} // Dodajte ovo
          setCheckDataMap={() => { }} // Dodajte praznu funkciju ili pravu implementaciju
          onSubmitSuccess={handleSuccess}
          onStateChange={setSubmissionState}
        />
      </Modal.Body>
    </Modal>
  );
};